module.exports = __webpack_public_path__ + "media/src/images/balloons/blue_gradient-b6802fcde0491d154a4769e51d8732f4.png";